import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import Footer from '../Layouts/Footer';
import API from '../Function/APILink'
import Datetime from '../Function/Datetime';
import FontAwesome from 'react-fontawesome'
import Preload from '../Layouts/Preload';
import HeaderDetail from '../Layouts/HeaderDetail';
import GoTop from '../Function/GoTop';

export class Draft extends Component {

    constructor(props){
        super(props)

        this.componentDidMount = this.componentDidMount.bind(this)
        this.state = {
            title: '',
            description: '',
            content: '',
            onairdate: '',
            view: 0,
            helpful: 0,
            tag: [],
            totalrecord: 0,
            lastedit: '',
            token: 'qwertygf123456',
            preloader: true
        }
    }

    async componentDidMount() {
        const url = this.props.match.params.url

        await API.get("GetContentDraf.php?token="+this.state.token+"&url="+url)
        .then(response => {
            this.setState({
                id: response.data["RECORD"].ContentID,
                title: response.data["RECORD"].Title,
                description: response.data["RECORD"].Description,
                content: response.data["RECORD"].Content,
                onairdate: response.data["RECORD"].OnAirDate,
                view: response.data["RECORD"].View,
                helpful: response.data["RECORD"].Helpful,
                category1: response.data["RECORD"].CatName_1,
                category2: response.data["RECORD"].CatName_2,
                category3: response.data["RECORD"].CatName_3,
                lastedit: response.data["RECORD"].LastEdit,
                preloader: false
            })
            if(response.data["TOTAL_RECORD"]===0){
                this.props.history.push("/")
            } else {
                API.get("GetTagDetail.php?token="+this.state.token+"&url="+url)
                .then(response => {
                    this.setState({
                        tag: response.data["RECORD"]
                    })
                })
                .catch(error => {
                    this.setState({
                        tag: []
                    })
                })
            }
        })
        .catch(error => {
            this.setState({
                id: '',
                title: '',
                description: '',
                content: '',
                onairdate: '',
                view: '',
                helpful: '',
                category1: '',
                category2: '',
                category3: '',
                lastedit: '',
                preloader: false
            })
        })
    }

    render() {
        
        const { 
            title, description, content, onairdate, tag, view, helpful,
            category1, category2, category3, lastedit,
            preloader
        } = this.state
        var rendertag
        
        rendertag = (
            tag.map(tag => {
                return <span key={tag.TagID}>{tag.Tag}</span>
            })
        )

        return (
            <>
                <Preload show={preloader} />
                <GoTop scrollStepInPx="50" delayInMs="30" />
                <HeaderDetail />
                <div className="body">
                    <div className="draf">
                        <div className="drafbox"></div>
                        <div className="draftext">Draf</div>
                    </div>
                    <div className="content-detail">
                        <div className="category">
                            {(null!==category1) ? ReactHtmlParser(category1) : ''}
                            {(null!==category2) ? ' / ' + ReactHtmlParser(category2) : ''}
                            {(null!==category3) ? ' / ' + ReactHtmlParser(category3) : ''}
                        </div>
                        <div className="title">{title}</div>
                        <div className="remark">
                            <span><Datetime input={onairdate}/> </span>
                            <span className="gf-green" title={`Jumlah dilihat: ${view}`}><FontAwesome name="eye"/> {view} </span>
                            <span className="gf-orange" title={`Jumlah terbantu: ${helpful}`}><FontAwesome name='star'/> {helpful}</span>
                        </div>
                        <hr/>
                        <div className="value">
                            {description}
                            <br/>
                            {ReactHtmlParser(content)}
                        </div>
                        <div className="tag">
                            Tag: {rendertag}
                        </div>
                        <hr/>
                        <div className="lastupdate">
                            Terakhir diperbaharui: {(lastedit > onairdate) ? <Datetime input={lastedit}/> : <Datetime input={onairdate}/>}
                        </div>
                        <div className="response">
                            Apakah konten ini membantu?
                            <button className="btn btn-green disabled" disabled>Iya</button>
                            <button className="btn btn-red disabled" disabled>Belum</button>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
}

export default Draft
